// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navbar__text{margin:0;letter-spacing:.1em;text-transform:uppercase}.navbar__text__container{display:gap;padding-block:12px}.navbar__text__main{font-size:14px;font-weight:500}.navbar__text__sub{font-size:14px;font-weight:300}", ""]);
// Exports
export default exports;
